import 'babel-polyfill';

import Vue from 'vue';

import svg_icons from './common/svg_icons.vue';
import contact_form from './public/contact_form/index.vue';

// SASS/CSS
import 'flatpickr/dist/flatpickr.css';
import '../../css/sass/public.scss';

// disable the warning about dev/prod
Vue.config.productionTip = false;

Vue.component('ybw-appointment-form', function (resolve) {
    require(['./public/appointment_form/index.vue'], resolve);
});

new Vue({
    el: '#app',
    components: {
        'svg-icons': svg_icons,
        'ybw-contact-form': contact_form,
    },

    data: {
        showMobileMenu: false,
    },

    mounted() {
        this.$nextTick(() => {
            window.addEventListener('resize', this.windowResize);
        });
    },

    methods: {
        windowResize() {
            this.showMobileMenu = false;
        },
    },
});


// WEBPACK FOOTER //
// ./html/js/src/public.js